import { RaceProgram, RaceWagerType } from "@tvg/ts-types/Race";
import { RunnerBI } from "@tvg/pp/src/hooks/useGetRunnerFromBI";
import { FreePastPerformanceData } from "@tvg/pp/src/components/Main/ScrollablePicksRacecard/types";
import {
  RunnerModifierEnum,
  RunnerSortByEnum,
  RunnerSortOrderEnum
} from "@tvg/pp/src/types";

export enum PickViewOptionsEnum {
  QUICK_PICK = "quickPick",
  HANDICAPPING = "handicapping"
}

export enum Layout {
  EXTENDED = "extended",
  CONDENSED = "condensed"
}

export interface PicksSelectorProps {
  isMobile?: boolean;
  isBetSlipVisible?: boolean;
  runnerModifier?: RunnerModifierEnum;
  runnerSortOrder?: RunnerSortOrderEnum;
  runnerSortBy?: RunnerSortByEnum;
  renderRunnerModifier?: (
    currentRace: RaceProgram,
    isPicks?: boolean,
    legIndex?: number
  ) => JSX.Element;
  currentRace: RaceProgram;
  races: RaceProgram[];
  selectedBetType?: RaceWagerType;
  selections: string[][];
  isOnModal?: boolean;
  onClickBetButton: (
    runner: string | RunnerBI,
    type: string,
    position?: number,
    module?: string,
    activeSourceName?: string,
    isQuickPick?: boolean,
    isAlternatesView?: boolean
  ) => void;
  onClickActiveBetsButton?: () => void;
  onClickWatchReplay?: () => void;
  freePastPerformanceData?: FreePastPerformanceData;
  layout?: Layout;
  isDisabled?: boolean;
  minWidth?: number;
  hasScrolled?: boolean;
  isWagerPad?: boolean;
  pathname?: string;
  isAlternatesView?: boolean;
}
